import {registerBlockType} from '@wordpress/blocks';
import {InspectorControls, RichText, useBlockProps, ColorPalette} from "@wordpress/block-editor";
import {
    Panel,
    PanelBody,
    PanelRow,
    ToggleControl,
    TextControl
} from '@wordpress/components';
import {__} from "@wordpress/i18n";

registerBlockType(
    'quiety-block/quiety-contact-info-widget', {
        title: 'Quiety Contact Info Widget',
        icon: 'phone',
        category: 'widgets',
        keywords: ['contact info', 'quiety', 'contact'],
        attributes: {

            title: {
                type: 'string',
                source: 'html',
                selector: 'h4',
            },

            iconColor: {
                type: 'string',
            },

            textColor: {
                type: 'string',
            },

            phone: {
                type: 'string',
                source: 'html',
                selector: '.quiety-block-phone-number',
            },

            email: {
                type: 'string',
                source: 'html',
                selector: '.quiety-block-email-id',
            },

            location: {
                type: 'string',
                source: 'html',
                selector: '.quiety-block-location-address',
            },

            showSociallinks: {
                type: 'boolean',
                default: false
            },
            facebook: {
                type: 'string',
                source: 'attribute',
                selector: '.ultraland-social-facebook',
                attribute: 'href'
            },

            twitter: {
                type: 'string',
                source: 'attribute',
                selector: '.ultraland-social-twitter',
                attribute: 'href'
            },

            instagram: {
                type: 'string',
                source: 'attribute',
                selector: '.ultraland-social-instagram',
                attribute: 'href'
            },
            dribbble: {
                type: 'string',
                source: 'attribute',
                selector: '.ultraland-social-dribbble',
                attribute: 'href'
            },
            linkedin: {
                type: 'string',
                source: 'attribute',
                selector: '.ultraland-social-linkedin',
                attribute: 'href'
            },
        },
        supports: {
            color: true // Enables background and text
        },


        edit: ({attributes, setAttributes}) => {
            const {
                title,
                phone,
                email,
                location,
                facebook,
                twitter,
                instagram,
                dribbble,
                linkedin,
                iconColor,
                textColor,
                showSociallinks,
            } = attributes;

            return (
                <>
                    <InspectorControls>
                        <PanelBody title={__('Style')}>
                            <ColorPalette
                                label={__('Icon Color')}
                                value={ iconColor }
                                onChange={ ( colorValue ) => setAttributes( { iconColor: colorValue } ) }
                                allowReset
                            />

                            <ColorPalette
                                label={__('Text Color')}
                                value={ textColor }
                                onChange={ ( colorValue ) => setAttributes( { textColor: colorValue } ) }
                                allowReset
                            />
                        </PanelBody>
                        <PanelBody title={__('Social Links')}>
                            <ToggleControl label={__('Show Social-links')} value={showSociallinks} checked={showSociallinks} onChange={val => setAttributes({showSociallinks: val})}/>

                            {showSociallinks &&
                            <>
                                <TextControl label={__('Facebook')} value={facebook} onChange={val => setAttributes({facebook: val})}/>
                                <TextControl label={__('Twitter')} value={twitter} onChange={val => setAttributes({twitter: val})}/>
                                <TextControl label={__('Instagram')} value={instagram} onChange={val => setAttributes({instagram: val})}/>
                                <TextControl label={__('Dribbble')} value={dribbble} onChange={val => setAttributes({dribbble: val})}/>
                                <TextControl label={__('Linkedin')} value={linkedin} onChange={val => setAttributes({linkedin: val})}/>
                            </>
                            }
                        </PanelBody>
                    </InspectorControls>
                    <div className="ultraland_block_contact_info_widget">
                        <ul className="quiety-block-contact-info">
                            <li className="quiety-block-phone">
                                <i className="fas fa-phone-alt" style={{ color: iconColor }} ></i>

                                <RichText
                                    key="phone"
                                    className="icon-label quiety-block-phone-number"
                                    tagName="span"
                                    value={phone}
                                    allowedFormats={['core/bold', 'core/italic']}
                                    onChange={(phone) => setAttributes({phone})}
                                    placeholder="Phone..."
                                />
                            </li>


                            <li className="quiety-block-email">
                                <i className="far fa-envelope"></i>

                                <RichText
                                    key="email"
                                    className="quiety-block-email-id"
                                    tagName="span"
                                    value={email}
                                    allowedFormats={['core/bold', 'core/italic']}
                                    onChange={(email) => setAttributes({email})}
                                    placeholder="Email..."
                                />
                            </li>

                            <li className="quiety-block-location">
                                <i className="fas fa-map-marker-alt"></i>

                                <RichText
                                    key="location"
                                    className="quiety-block-location-address"
                                    tagName="span"
                                    value={location}
                                    allowedFormats={['core/bold', 'core/italic']}
                                    onChange={(location) => setAttributes({location})}
                                    placeholder="Location..."
                                />
                            </li>

                        </ul>


                        {showSociallinks && (facebook || twitter || instagram || linkedin || dribbble || title) &&
                        <>

                            <RichText
                                key="title"
                                className="quiety-block-social-title"
                                tagName="h4"
                                value={title}
                                allowedFormats={['core/bold', 'core/italic']}
                                onChange={(title) => setAttributes({title})}
                                placeholder="Social Title..."
                            />

                            <ul className="quiety-block-social-link">
                                {facebook &&
                                <li>
                                    <a className="ultraland-social-facebook"><i className="fab fa-facebook"/></a>
                                </li>
                                }
                                {twitter &&
                                <li>
                                    <a className="ultraland-social-twitter"><i className="fab fa-twitter"/></a>
                                </li>
                                }
                                {instagram &&
                                <li>
                                    <a className="ultraland-social-instagram"><i className="fab fa-instagram"/></a>
                                </li>
                                }
                                {linkedin &&
                                <li>
                                    <a className="ultraland-social-linkedin"><i className="fab fa-linkedin"/></a>
                                </li>
                                }
                                {dribbble &&
                                <li>
                                    <a className="ultraland-social-dribbble"><i className="fab fa-dribbble"/></a>
                                </li>
                                }
                            </ul>
                        </>
                        }
                    </div>

                </>
            )
        },

        save: ({attributes}) => {
            const {
                title,
                phone,
                email,
                location,
                facebook,
                twitter,
                instagram,
                linkedin,
                dribbble,
                iconColor,
                textColor,
                showSociallinks
            } = attributes;

            return (
                <>
                    <div className="ultraland_block_contact_info_widget">

                        {(phone || email || location) &&
                        <ul className="quiety-block-contact-info">
                            {phone &&
                            <li className="quiety-block-phone">
                                <i className="feather-phone" style={{ color: iconColor }}></i>
                                <span className="quiety-block-phone-number" style={{ color: textColor }}>{phone}</span>
                            </li>
                            }

                            {email &&
                            <li className="quiety-block-email">
                                <i className="feather-mail" style={{ color: iconColor }}></i>
                                <span className="quiety-block-email-id" style={{ color: textColor }}>{email}</span>
                            </li>
                            }
                            {location &&
                            <li className="quiety-block-location">
                                <i className="feather-map-pin" style={{ color: iconColor }}></i>
                                <span className="quiety-block-location-address" style={{ color: textColor }}> {location}</span>
                            </li>
                            }
                        </ul>
                        }

                        {showSociallinks && (facebook || twitter || instagram || linkedin || dribbble || title) &&
                        <>
                            <h4 className="quiety-block-social-title">{title}</h4>
                            <ul className="quiety-block-social-link">
                                {facebook &&
                                <li>
                                    <a href={facebook} className="ultraland-social-facebook" target="_blank"
                                       rel="noopener noreferrer"><i className="fa fa-facebook"/></a>
                                </li>
                                }
                                {twitter &&
                                <li>
                                    <a href={twitter} className="ultraland-social-twitter" target="_blank"
                                       rel="noopener noreferrer"><i className="fa fa-twitter"/></a>
                                </li>
                                }
                                {instagram &&
                                <li>
                                    <a href={instagram} className="ultraland-social-instagram" target="_blank"
                                       rel="noopener noreferrer"><i className="fa fa-instagram"/></a>
                                </li>
                                }
                                {linkedin &&
                                <li>
                                    <a href={linkedin} className="ultraland-social-linkedin" target="_blank"
                                       rel="noopener noreferrer"><i className="fa fa-linkedin"/></a>
                                </li>
                                }
                                {dribbble &&
                                <li>
                                    <a href={dribbble} className="ultraland-social-dribbble" target="_blank"
                                       rel="noopener noreferrer"><i className="fa fa-dribbble"/></a>
                                </li>
                                }
                            </ul>
                        </>
                        }
                    </div>
                </>
            )
        }
    }
);